import React from 'react';
import {orgId} from '../../../context/context';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';

export default class Step3 extends React.Component {

  render() {
    return <div className={this.props.className || ''}>
      <ul style={{ lineHeight: '1.8em' }}>
        <li>On your online store, add a product to the cart and open the cart page.</li>
        <li>Fill out the form and place the order as a test order (for more details please refer to the <OpenInNewLink href="https://help.shopify.com/en/manual/checkout-settings/test-orders">Shopify documentation</OpenInNewLink>).</li>
        <li>In your Shopify admin, under &apos;Orders&apos; &gt; #order_id &gt; &apos;Additional details&apos; you should see the form values. Please <a href={`/get-in-touch?shop=${orgId}`}>get in touch</a> if not.</li>
      </ul>
    </div>
  }

}
